module.exports = __webpack_public_path__ + "img/movie.37c6f875.png";